import React from "react";
import { isMobile } from "react-device-detect";

import FederalSearchResultsMobile from "./FederalSearchResultsMobile";
import FederalSearchResultsDesktop from "./FederalSearchResultsDesktop";

function FederalSearchResults(props) {
  return isMobile ? <FederalSearchResultsMobile {...props} /> : <FederalSearchResultsDesktop {...props} />;
}

export default FederalSearchResults;
